import Resizer from "react-image-file-resizer";

const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      800,
      800,
      "jpeg",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

export const handleImgResizer = async (e) => {
  const file = e.target.files[0];
  try {
    return resizeFile(file);
  } catch (err) {
    return null;
  }
};

export const handleFileResizer = async (file) => {
  try {
    return resizeFile(file);
  } catch (err) {
    return null;
  }
};
